import React, { useReducer, useCallback } from 'react'
import PropTypes from 'prop-types'
import { isUndefined } from 'lodash'

import { Box, Button, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { formData } from '@scoir/api'
import LoadStateIndicator from './LoadStateIndicator'
import reducer, { actionTypes, initialState } from './reducer'

export const getDefaultErrorMessage = () => 'An error has occured...'

export const getFormData = (field, file) => {
  const data = new FormData()
  data.append(field, file)
  return data
}

const useStyles = makeStyles({
  input: {
    height: 0,
    width: 0,
    display: 'none',
  },
})

const UploadFileButton = ({
  acceptedFileType = '.csv',
  dataField = 'DataFile',
  getErrorMessage = getDefaultErrorMessage,
  label = 'Choose a file',
  onUploadSuccess,
  postApiEndpoint,
  onPreprocessFile,
  disabled = false,
}) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { loading, success, failure, error, fileName } = state
  const classes = useStyles()
  const onUpload = useCallback(
    async (file) => {
      dispatch({
        type: actionTypes.load,
        fileName: file.name,
      })
      let workingFile = file
      if (!isUndefined(onPreprocessFile)) {
        workingFile = onPreprocessFile(file)
      }
      formData
        .post(postApiEndpoint, getFormData(dataField, workingFile))
        .then((response) => {
          dispatch({ type: actionTypes.success })
          onUploadSuccess(response, file)
        })
        .catch((response) => {
          dispatch({
            type: actionTypes.failure,
            error: getErrorMessage(response),
          })
        })
    },
    [postApiEndpoint, onUploadSuccess, getErrorMessage, dataField, onPreprocessFile],
  )

  return (
    <Box
      display="inline-flex"
      alignItems="center"
      flexWrap="wrap"
    >
      <Button
        htmlFor="upload-student-data-input"
        variant="contained"
        color="primary"
        component="label"
        disabled={loading === true || disabled}
        onKeyDown={(e) => {
          if (e.key === ' ' || e.key === 'Enter') {
            e.target.click()
          }
        }}
      >
        {label}
        <input
          id="upload-student-data-input"
          className={classes.input}
          type="file"
          accept={acceptedFileType}
          tabIndex="-1"
          disabled={loading === true}
          aria-invalid={failure}
          onChange={(e) => onUpload(e.target.files[0])}
        />
      </Button>
      <Box p={1}>
        <Typography variant="body1">
          <strong>{fileName}</strong>
        </Typography>
      </Box>
      <Box>
        <LoadStateIndicator
          isError={failure}
          errorText={error}
          isLoading={loading}
          isSuccess={success}
        />
      </Box>
    </Box>
  )
}

UploadFileButton.propTypes = {
  label: PropTypes.string.isRequired,
  dataField: PropTypes.string.isRequired,
  acceptedFileType: PropTypes.string.isRequired,
  postApiEndpoint: PropTypes.string.isRequired,
  onUploadSuccess: PropTypes.func.isRequired,
  getErrorMessage: PropTypes.func.isRequired,
  onPreprocessFile: PropTypes.func,
  disabled: PropTypes.bool,
}

export default UploadFileButton
